/* eslint-disable */
import types from './types';
import { Api } from 'services/api';
import { Realtime } from 'services/websocket';
import { AppMessenger } from 'utils';
import { decodeJwt } from 'utils/decodeJwt';
// eslint-disable-next-line id-match
import { SET_JWT } from 'widgetActions';

/**
 * @param {String} reducerType
 * @returns {{type: *}}
 */
export const request = (reducerType, additionalData) => ({
  type: reducerType,
  additionalData,
});

/**
 * @param {String} reducerType
 * @param response
 * @returns {{type: *, payload: *}}
 */
export const success = (reducerType, response) => ({
  type: reducerType,
  payload: response,
});

/**
 * @param {String} reducerType: will be set NETWORK_FAILURE if there's been a detected connection issue.
 * @param {String} error
 * @returns {{type: *, errorMessage: *}}
 */
export const failure = (reducerType, error) => ({
  type: reducerType,
  error,
});

export const setSession = (session) => ({ type: types.SET_SESSION, payload: session });

/**
 * The JC init call will add the candidate as well.
 * The candidate ID will be encoded in the respond token.
 */
export const initializeAndAddCandidate =
  ({ jobChatId, firstName, lastName, phoneNumber, extras = {} }) =>
  (dispatch) => {
    dispatch(request(types.ADD_REQUEST));
    Api.initialize({ jobChatId, firstName, lastName, phoneNumber, extras }).then(
      (response) => {
        const { token } = response;
        AppMessenger.sendMessageToWidget({
          action: SET_JWT,
          additionalData: { jwt: token },
        });
        const decodedJwt = decodeJwt(token);
        dispatch(success(types.ADD_SUCCESS, decodedJwt));
      },
      (error) => dispatch(failure(types.ADD_FAILURE, error)),
    );
  };

export const initializeAnonWithFirstMessage =
  ({ text, callback }) =>
  (dispatch) => {
    dispatch(request(types.ANON_INIT_REQUEST));
    Api.initializeAnonWithFirstMessage(text).then(
      (response) => {
        AppMessenger.sendMessageToWidget({
          action: SET_JWT,
          additionalData: { jwt: response.token },
        });

        dispatch(success(types.ANON_INIT_SUCCESS, response));
        callback(response);
      },
      (error) => dispatch(failure(types.ANON_INIT_FAILURE, error)),
    );
  };

export const addCandidate =
  ({ firstName, lastName, phoneNumber }) =>
  (dispatch) => {
    dispatch(request(types.ADD_REQUEST));
    Api.addCandidate({ firstName, lastName, phoneNumber }).then(
      (response) => dispatch(success(types.ADD_SUCCESS, response)),
      (error) => dispatch(failure(types.ADD_FAILURE, error)),
    );
  };

export const setDefaultAriText = (text) => (dispatch) => {
  dispatch(request(types.SET_FAKE_MESSAGE, { text }));
};

export const addDefaultAriText = (text) => (dispatch) => {
  dispatch(request(types.ADD_FAKE_MESSAGE, { type: 1, text }));
};

export const sendMessage =
  ({ firstName, lastName, phoneNumber, text, jobChatId, callback }) =>
  (dispatch) => {
    dispatch(request(types.SEND_MESSAGE_REQUEST, { text }));
    Api.sendMessage({ firstName, lastName, phoneNumber, text, jobChatId }).then(
      (response) => {
        dispatch(success(types.SEND_MESSAGE_SUCCESS, response));
        if (callback) {
          callback(response);
        }
      },
      (error) => dispatch(failure(types.SEND_MESSAGE_FAILURE, error)),
    );
  };

export const spoofCandidateMessage = (text, sentVia) => (dispatch) => {
  dispatch(request(types.ADD_FAKE_MESSAGE, { type: 0, text, sentVia }));
};

export const sendPreviouslySpoofedMessage =
  ({ firstName, lastName, phoneNumber, text, jobChatId, callback }) =>
  (dispatch) => {
    Api.sendMessage({ firstName, lastName, phoneNumber, text, jobChatId }).then(
      () => {
        if (callback) {
          callback();
        }
      },
      (error) => dispatch(failure(types.SEND_MESSAGE_FAILURE, error)),
    );
  };

export const sendAnonMessage =
  ({ text, jobChatId }) =>
  (dispatch) => {
    dispatch(request(types.SEND_MESSAGE_REQUEST, { text }));
    Api.sendAnonMessage({ text, jobChatId }).then(
      (response) => dispatch(success(types.SEND_MESSAGE_SUCCESS, response)),
      (error) => dispatch(failure(types.SEND_MESSAGE_FAILURE, error)),
    );
  };

export const getMessages =
  ({ jobChatId, candidateId, callback }) =>
  (dispatch) => {
    dispatch(request(types.GET_MESSAGES_REQUEST));
    Api.getMessages({ jobChatId, candidateId }).then(
      (response) => {
        dispatch(success(types.GET_MESSAGES_SUCCESS, response));
        if (callback) {
          callback(response);
        }
      },
      (error) => dispatch(failure(types.GET_MESSAGES_FAILURE, error)),
    );
  };

export const uploadResumeReq = () => (dispatch) => {
  dispatch(request('UPLOAD_RESUME'));
};

export const enterChat = () => (dispatch) => {
  dispatch(request(types.ENTER_CHAT));
};

export const setIsAnon = () => (dispatch) => {
  dispatch(request(types.SET_IS_ANON));
};

export const resetApp = () => async (dispatch) => {
  Realtime.disconnect();
  dispatch({ type: types.RESET_APP });
};

export const realTimeMsg = (message) => (dispatch) => {
  dispatch(success(types.REAL_TIME_MSG, { message }));
};

export const toggleWidget = () => (dispatch) => {
  dispatch(request(types.TOGGLE_WIDGET));
};

export const setIsChatWidgetOpen = () => (dispatch) => {
  dispatch(request(types.SET_IS_CHAT_WIDGET_OPEN));
};
